export default __webpack_public_path__ + "static/0172-2e9b4d7f6ff5567818d3409dc836c046.png";